module.exports = __webpack_public_path__ + "static/media/parkir.87f6a1d3.png";